import React from 'react';
import { array, func } from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import { FiPaperclip } from 'react-icons/fi';
import {
  StagedAttachmentChips,
  AttachmentHints,
  useAttachmentFilePicker,
  useUnsavedAttachmentsWarning,
} from '../../components/MessageAttachmentsPicker/MessageAttachmentsPicker';
import { MAX_MESSAGE_ATTACHMENTS } from '../../util/fileAttachments';

import css from './CustomOfferForm.css';

// The "Liitteet" block of the offer form: a labelled attach button, the
// staged file chips and the upload hints, built from the same primitives as
// the chat and enquiry composers. A function component so it can use the
// picker hooks; CustomOfferForm itself is a class.
const OfferAttachmentsPicker = props => {
  const { stagedAttachments, onUploadAttachment, onRemoveAttachment } = props;
  const {
    fileInputRef,
    pickErrorId,
    clearPickError,
    handleFilesSelected,
    openFilePicker,
  } = useAttachmentFilePicker({ stagedAttachments, onUploadAttachment });

  // Files already on the offer are seeded with tempId === fileId and are not
  // lost on unload; only this session's uploads are.
  useUnsavedAttachmentsWarning(stagedAttachments.some(a => a.tempId !== a.fileId));

  const handleRemove = tempId => {
    clearPickError();
    onRemoveAttachment(tempId);
  };
  const attachDisabled = stagedAttachments.length >= MAX_MESSAGE_ATTACHMENTS;

  return (
    <div className={css.attachmentsBlock}>
      <h4 className={css.attachmentsTitle}>
        <FormattedMessage id="CustomOfferForm.attachmentsTitle" />
      </h4>
      <button
        type="button"
        className={css.attachButton}
        onClick={openFilePicker}
        disabled={attachDisabled}
      >
        <FiPaperclip className={css.attachIcon} />
        <FormattedMessage id="CustomOfferForm.attachButton" />
      </button>
      <input
        ref={fileInputRef}
        className={css.fileInput}
        type="file"
        multiple
        onChange={handleFilesSelected}
      />
      {stagedAttachments.length > 0 ? (
        <StagedAttachmentChips
          className={css.attachmentChips}
          attachments={stagedAttachments}
          onRemove={handleRemove}
        />
      ) : null}
      <AttachmentHints attachments={stagedAttachments} pickErrorId={pickErrorId} />
    </div>
  );
};

OfferAttachmentsPicker.propTypes = {
  stagedAttachments: array.isRequired,
  onUploadAttachment: func.isRequired,
  onRemoveAttachment: func.isRequired,
};

export default OfferAttachmentsPicker;
